"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const styles_css_1 = __importDefault(require("./styles.css"));
const dispatchers_1 = require("../../../utility/dispatchers");
const c = {
    navBar: `${layout_css_1.default.flex} ${util_css_1.default.ulReset} ${styles_css_1.default.navBar}`,
    item: ({ isActive }) => [layout_css_1.default.padding15, typography_css_1.default.bold, styles_css_1.default.navItem, isActive ? styles_css_1.default.activeTab : ''].join(' '),
};
const Nav = ({ activeTab, setActiveTabs, pendingChanges }) => {
    const navItems = [
        { title: 'Overview', path: 'overview' },
        { title: 'Description', path: 'description' },
        { title: 'Rules', path: 'rules' },
        { title: 'Surveys', path: 'surveys' },
        { title: 'Prizes', path: 'prizes' },
        { title: 'Settings', path: 'settings' },
        { title: 'Winners', path: 'winners' },
        { title: 'Mail-In', path: 'mailIn' },
    ];
    const handleTabChange = ({ path }) => {
        if (pendingChanges.size === 0) {
            setActiveTabs(path);
        }
        else {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: 'You have unsaved changes',
                type: 'error',
            });
        }
    };
    return (react_1.default.createElement("ul", { className: c.navBar }, navItems.map(({ title, path }) => (react_1.default.createElement("li", { key: path, className: c.item({ isActive: activeTab === path }), onClick: () => handleTabChange({ path }) }, title)))));
};
exports.default = Nav;
